// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ly","controlPlay":"lz","controlElement":"lA","lowerControlWrapper":"lB","lowerControlIconWrapper":"lC","lowerControlIcon":"lD","show":"lE"};